import SignalRService from "@/typescript/Services/SignalRService";
import { defineStore } from "pinia";

/**
 * 任务统计对象
 */
export class TaskStatisticeVO {
    /** 正在运行的 AI 任务数 */
    AiTaskRunCount: number = 0;

    /** 正在运行的期货合约任务数 */
    FuturesRuncount: number = 0;

    /** 正在运行的期权任务数 */
    OptionRunCount: number = 0;

    /** 正在运行的现货交易任务数 */
    SpottradeRunCount: number = 0;

    /** 已完成的 AI 任务数 */
    AiTaskFinishCount: number = 0;

    /** 已完成的期货合约任务数 */
    FuturesFinishcount: number = 0;

    /** 已完成的期权任务数 */
    OptionFinishCount: number = 0;

    /** 已完成的现货交易任务数 */
    SpottradeFinishCount: number = 0;
}


/**
 * 任务统计
 */
export const useTaskStatisticeStore = defineStore('taskStatistice', {
    state: () => ({
        taskStatistice: new TaskStatisticeVO(),
    }),
    getters: {
        HasAi: (state) => state.taskStatistice.AiTaskRunCount > 0
    },
    actions: {
        /**
         * 加载监听器
         */
        InitEventAsync() {
            SignalRService.Instance.AddEvent("TaskStatistics", (data: TaskStatisticeVO) => {
                Object.assign(this.taskStatistice, data);
            });
        }
    }
})  